import type { ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#007bff',
    colorInfo: '#007bff',
    colorSuccess: '#00b746',
    colorError: '#dd0404',
    colorWarning: '#f3af00',
    colorTextBase: '#001029',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f8f8f8',
    colorBgBase: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBorder: '#D9D9D9',
    colorBorderSecondary: '#F0F0F0',

    fontFamily: "'Rubik', system-ui, -apple-system, sans-serif",
    fontSize: 14,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSizeXL: 20,
    fontSizeHeading1: 32,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,

    sizeStep: 5,
    sizeUnit: 5,
    marginXXS: 5,
    marginXS: 10,
    marginSM: 15,
    margin: 20,
    marginMD: 25,
    marginLG: 30,
    marginXL: 35,
    marginXXL: 40,
    paddingXXS: 5,
    paddingXS: 10,
    paddingSM: 15,
    padding: 20,
    paddingMD: 25,
    paddingLG: 30,
    paddingXL: 35,

    controlHeight: 30,
    controlHeightLG: 40,

    borderRadiusSM: 8,
    borderRadius: 16,
    borderRadiusLG: 16,

    boxShadow:
      '0 6px 16px 0 rgba(0,0,0,0.08), 0 3px 6px -4px rgba(0,0,0,0.12), 0 9px 28px 8px rgba(0,0,0,0.05)',
    boxShadowSecondary:
      '0 6px 16px 0 rgba(0,0,0,0.08), 0 3px 6px -4px rgba(0,0,0,0.12), 0 9px 28px 8px rgba(0,0,0,0.05)',
  },
  components: {
    Card: {
      borderRadiusLG: 8,
    },
    Segmented: {
      itemSelectedBg: '#007bff',
      itemSelectedColor: '#fff',
    },
    InputNumber: {
      handleWidth: 20,
    },
  },
};
